/* Native details provide the disclosures without JavaScript. Names are unique
   per section; this also supports browsers without exclusive details groups. */
if (!customElements.get("nmn-accordion-group")) {
  customElements.define(
    "nmn-accordion-group",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const disclosures = Array.from(this.querySelectorAll("details"));
        disclosures.forEach((disclosure) => {
          disclosure.addEventListener("toggle", () => {
            if (!disclosure.open) return;
            disclosures.forEach((other) => {
              if (other !== disclosure) other.open = false;
            });
          }, options);
        });

        if (!window.Shopify?.designMode) return;
        document.addEventListener("shopify:block:select", (event) => {
          if (!this.contains(event.target)) return;
          const block = event.target.closest("[data-accordion-block-id]");
          if (!block) return;
          const disclosure = disclosures.find((item) => item.dataset.accordionBlockId === block.dataset.accordionBlockId);
          if (!disclosure || !disclosure.getClientRects().length) return;
          disclosure.open = true;
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
